import {Component, Input} from '@angular/core';
import {BehaviorSubject} from 'rxjs';

@Component({
  selector: 'app-cabecalho-rota',
  templateUrl: './cabecalho-rota.component.html',
  styleUrls: ['./cabecalho-rota.component.scss'],
})
export class CabecalhoRotaComponent {
  @Input() dados!: { identificador: string, nome?: string, motorista?: string, placa: string, placaCarroceria?: string, codigoVeiculo?: string, codigoCarroceria?: string };
  @Input() loaded!: BehaviorSubject<boolean>;
  @Input() camposGrid!: string[];
  @Input() rastreamento?: string;


}
